import { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { RTABAK_URLS } from "../../utils/urls";
import ItemDetail from "../ItemDetail";
import useDevice from "../../utils/hooks/useDevice";
import ItemDetailMobile from "../ItemDetailMobile";
import { useAsync } from "../../utils/hooks/useAsync";
import { ProductServices } from "../../services/products";
import { VariationService } from "../../services/variations";
import Loading from "../common/Loading";
import { carouselServices } from "../../services/carousels";
import request from "../../services/request";
import { AuthContext } from "../../context/AuthContext";

const ItemDetailContainer = () => {
  const { isAuth } = useContext(AuthContext);
  const [product, setProduct] = useState<Product>();
  const [variations, setVariations] = useState<Variation[]>();
  const [manufacturingCost, setManufacturingCost] =
    useState<ManufacturingCost[]>();
  const [carousel, setCarousel] = useState<CarouselExtended>();
  const { isLoading, isSuccess, run } = useAsync();
  const { friendlyUrl } = useParams();

  useEffect(() => {
    run(
      ProductServices.getProductByFriendlyUrl({
        friendlyUrl: friendlyUrl,
      })
    ).then((res: any) => {
      setProduct(res.data);
      run(VariationService.getVariationsByProductId({ id: res.data._id })).then(
        (res: any) => {
          setVariations(res.data);
        }
      );
      run(
        carouselServices
          .getCarouselByName({ name: res.data.department.toUpperCase() })
          .then((res: any) => {
            setCarousel(res.data);
          })
      );
    });

    request({
      baseURL: RTABAK_URLS.API.GetManufacturingCost,
      method: "GET",
      headers: {
        Accept: "aplication/json",
      },
    }).then((res) => setManufacturingCost(res.data));
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [, friendlyUrl]);

  const { width } = useDevice();

  return (
    <>
      {isLoading && <Loading />}

      {isSuccess &&
        product &&
        variations &&
        manufacturingCost &&
        (width > 1024 ? (
          <>
            <ItemDetail
              product={product}
              variations={variations}
              manufacturingCost={manufacturingCost}
              carousel={carousel && carousel}
              isAuth={isAuth}
            />
          </>
        ) : (
          <ItemDetailMobile
            product={product}
            variations={variations}
            manufacturingCost={manufacturingCost}
            isAuth={isAuth}
          />
        ))}
    </>
  );
};

export default ItemDetailContainer;
